import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";
import moment from "moment";
import DownloadPopup from "../App/DownloadPopup";
import * as XLSX from "xlsx";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import { getAccessSettings } from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";
function COPA() {
  const globalState = useGlobalState();
  const [PTLogFilesCOPAData, setPTLogFilesCOPAData] = useState([]);

  const [copaSummaryData, setCOPASummaryData] = useState([]);

  const [showAnimation, setShowAnimation] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showCopaSummary, setshowCopaSummary] = useState(false);
  const [showCurrentLogData, setShowCurrentLogData] = useState(true);

  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState(
    "Data has been exported to file successfully.!"
  );

  const [quarterList, setQuarterList] = useState<any>([
    {
      PID: 1,
      Name: "Q1",
    },
    {
      PID: 2,
      Name: "Q2",
    },
    {
      PID: 3,
      Name: "Q3",
    },
    {
      PID: 4,
      Name: "Q4",
    },
  ]);

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: AppContext.FileUploadObjectTypeCOPAUpload,
    MaxAllowedFiles: 1,
    UploadType: 4,
    FolderName: "IBB",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [numericYear, setNumericYear] = useState(2023);
  const [numericQuarter, setNumericQuarter] = useState(2);
  const [PTLogFilesCOPAID, setPTLogFilesCOPAID] = useState(0);
  const [showInLC, setShowInLC] = useState(false);

  useEffect(() => {
    let DisplayMessage = "File has been uploaded.";
    setPopUpMessage(DisplayMessage);
    PTLogFilesCOPAGetFiles();
  }, []);

  useEffect(() => {
    if (PTLogFilesCOPAID > 0)
      IBBCOPAUploadDataGetDataByPTLogFilesCOPAIDAndNumericQuarter(
        PTLogFilesCOPAID,
        numericQuarter
      );
  }, [showInLC]);

  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
    setshowCopaSummary(true);
  }

  function PTLogFilesCOPAGetFiles() {
    let object = {} as any;
    object.appid = AppContext.App;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBCOPAUploadData/PTLogFilesCOPAGetFiles",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setPTLogFilesCOPAData(l_response[0]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function showPopUpForSaveFiles() {
    if (uploadFileList && uploadFileList.length > 0) SaveFiles();
    else
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Please select file to upload.",
      });
  }

  function SaveFiles() {
    if (uploadFileList && uploadFileList.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            PTLogFilesCOPAAddFiles(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
          //setShowAnimation(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      //saveConactUsData([]);
    }
  }

  function PTLogFilesCOPAAddFiles(p_S3UploadFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.filesdata = p_S3UploadFileList;
    object.numericyear = numericYear;
    object.numericquarter = numericQuarter;
    object.currencyid = showInLC ? 1 : 0;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBCOPAUploadData/PTLogFilesCOPAAddFiles",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setShowAnimation(false);

          PTLogFilesCOPAGetFiles();
          setCOPASummaryData(l_response[1]);

          let messageList = l_response[0][0].Message.split(",");

          let DisplayMessage = "Data has been imported.";

          for (let i = 0; i < messageList.length; i++) {
            DisplayMessage += "<br />" + messageList[i];
          }
          setPopUpMessage(DisplayMessage);
          setShowPopUp(true);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBCOPAUploadDataGetDataByPTLogFilesCOPAIDAndNumericQuarter(
    PTLogFilesCOPAID: number,
    QuarterID: any
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ptlogfilescopaid = PTLogFilesCOPAID;
    object.numericyear = numericYear;
    object.numericquarter = QuarterID;
    object.currencyid = showInLC ? 1 : 0;

    setPTLogFilesCOPAID(PTLogFilesCOPAID);
    setNumericQuarter(QuarterID);

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBCOPAUploadData/IBBCOPAUploadDataGetDataByPTLogFilesCOPAIDAndNumericQuarter",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setCOPASummaryData(result[0]);
          setShowAnimation(false);
          setshowCopaSummary(true);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);

    XLSX.writeFile(wb, name + ".xlsx");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>COPA History</a>
        </div>

        <DownloadPopup
          ShowPopup={showPopUp}
          FileLink={popUpFileURL}
          Message={popUpMessage}
          DownloadPopupCallBack={DownloadPopupCallBack}
        />

        <div className="page--data">
          <div className="flex-container">
            <span></span>
            <div className="flex-items">
              {getAccessSettings(2, 9) > 1 && (
                <>
                  <a
                    className="btn-link"
                    href="Uploads/COPA - Sample.xlsx"
                    download
                  >
                    Download Input File
                  </a>
                  <div className="centre-drop-cl">
                    <div className="drad-drop">
                      <DragDrop
                        ParentFeatures={dragDropFeatures}
                        DragDropCallback={handleDragDropCallback}
                        TriggerChild={triggerChild}
                      />
                    </div>
                    <div className="help-btns">
                      <a onClick={() => showPopUpForSaveFiles()}>Import Data</a>
                    </div>
                    <a
                      className="btn-primary"
                      title="Export"
                      onClick={() =>
                        DownloadClientsDataInExcel(
                          "tblProgramListCOPA",
                          "COPA HISTORY"
                        )
                      }
                    >
                      <img src="images/export.svg" width="18" height="18" />
                    </a>
                  </div>
                </>
              )}
              <span></span>
            </div>
          </div>

          <div className="section-table">
            <table className="part-head trend-table fixed-table">
              <thead>
                <tr>
                  <th>Uploaded By</th>
                  <th>Dated</th>
                  <th className="sm-col">Data File</th>
                  <th className="sm-col">View Summary</th>
                  {/* <th>Log File</th> */}
                </tr>
              </thead>
              <tbody>
                {PTLogFilesCOPAData &&
                  PTLogFilesCOPAData.map((item: any, index: any) => (
                    <React.Fragment key={"Main" + index}>
                      <tr>
                        <td>{item.Name}</td>
                        <td>
                          {moment(item.Dated).format("DD/MM/YYYY hh:mm:ss a")}
                        </td>
                        <td className="sm-col">
                          <div className="width-100 text-center btn-sm-grid">
                            <a
                              className="btn-primary btn-grid"
                              href={item.FileData}
                              target="blank"
                            >
                              <img
                                src="images/download.svg"
                                width={12}
                                height={12}
                              />
                            </a>
                          </div>
                        </td>
                        <td className="sm-col">
                          <div className="btn-sm-grid">
                            <a
                              className="btn-primary btn-grid"
                              onClick={() => {
                                setShowCurrentLogData(true);
                                IBBCOPAUploadDataGetDataByPTLogFilesCOPAIDAndNumericQuarter(
                                  item.PID,
                                  numericQuarter
                                );
                              }}
                            >
                              <img
                                src="images/eye.svg"
                                width={15}
                                height={15}
                              />
                            </a>
                          </div>
                        </td>
                        {/* <td>
                          <a
                            className="input-view"
                            href={item.LogFileData}
                            target="blank"
                          >
                            View
                          </a>
                        </td> */}
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
            <table
              className="part-head trend-table fixed-table no-display"
              id="tblProgramListCOPA"
            >
              <thead>
                <tr>
                  <th>Uploaded By</th>
                  <th>Dated</th>
                  {/* <th>Log File</th> */}
                </tr>
              </thead>
              <tbody>
                {PTLogFilesCOPAData &&
                  PTLogFilesCOPAData.map((item: any, index: any) => (
                    <React.Fragment key={"Main" + index}>
                      <tr>
                        <td>{item.Name}</td>
                        <td>
                          {moment(item.Dated).format("DD/MM/YYYY hh:mm:ss a")}
                        </td>
                        {/* <td className="sm-col">
                          <div className="width-100 text-center btn-sm-grid">
                            <a
                              className="btn-primary btn-grid"
                              href={item.FileData}
                              target="blank"
                            >
                              <img
                                src="images/download.svg"
                                width={12}
                                height={12}
                              />
                            </a>
                          </div>
                        </td> */}
                        {/* <td className="sm-col">
                          <div className="btn-sm-grid">
                            <a
                              className="btn-primary btn-grid"
                              onClick={() => {
                                setShowCurrentLogData(true);
                                IBBCOPAUploadDataGetDataByPTLogFilesCOPAIDAndNumericQuarter(
                                  item.PID,
                                  numericQuarter
                                );
                              }}
                            >
                              <img
                                src="images/eye.svg"
                                width={15}
                                height={15}
                              />
                            </a>
                          </div>
                        </td> */}
                        {/* <td>
                          <a
                            className="input-view"
                            href={item.LogFileData}
                            target="blank"
                          >
                            View
                          </a>
                        </td> */}
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showCopaSummary && (
        <div className="popup-help">
          <div className="help-popup-display lg-popup">
            <div className="help-inner lg-table" style={{ paddingBottom: 10 }}>
              <div className="help-head" style={{ margin: 0 }}>
                <h3>COPA Summary</h3>
                <a
                  className="close-help"
                  onClick={() => setshowCopaSummary(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div
                className="section-table copa-sum-tab"
                style={{ boxShadow: "none" }}
              >
                <table className="part-head trend-table fixed-table">
                  <thead>
                    <tr>
                      <th className="white-back" style={{ width: 100 }}></th>
                      <th className="white-back" style={{ width: 250 }}></th>
                      {showCurrentLogData && (
                        <th colSpan={9} className="p-relative th-height">
                          <div className="flex-items justify-center">
                            <a
                              className="th-a th-a-2"
                              onClick={() => {
                                setShowInLC(!showInLC);
                              }}
                            >
                              {showInLC ? "Show $ Values" : "Show LC Values"}
                            </a>
                            Values From this file
                            <select
                              className="select-md copa-quarter pad-all0"
                              value={numericQuarter}
                              onChange={(e) => {
                                IBBCOPAUploadDataGetDataByPTLogFilesCOPAIDAndNumericQuarter(
                                  PTLogFilesCOPAID,
                                  Number(e.target.value)
                                );
                              }}
                            >
                              {quarterList &&
                                quarterList.map((Item: any, index: any) => (
                                  <option
                                    value={Item.PID}
                                    key={"quarter" + Item.PID}
                                  >
                                    {Item.Name}
                                  </option>
                                ))}
                            </select>
                            <a
                              className="th-a"
                              onClick={() => {
                                setShowCurrentLogData(false);
                              }}
                            >
                              Show Quarter Total
                            </a>
                          </div>
                        </th>
                      )}
                      {!showCurrentLogData && (
                        <th colSpan={9} className="p-relative th-height">
                          <div className="flex-items justify-center">
                            <a
                              className="th-a th-a-2"
                              onClick={() => {
                                setShowInLC(!showInLC);
                              }}
                            >
                              {showInLC ? "Show $ Values" : "Show LC Values"}
                            </a>
                            Quarter Total
                            <select
                              className="select-md copa-quarter pad-all0"
                              value={numericQuarter}
                              onChange={(e) => {
                                IBBCOPAUploadDataGetDataByPTLogFilesCOPAIDAndNumericQuarter(
                                  PTLogFilesCOPAID,
                                  Number(e.target.value)
                                );
                              }}
                            >
                              {quarterList &&
                                quarterList.map((Item: any, index: any) => (
                                  <option
                                    value={Item.PID}
                                    key={"quarter" + Item.PID}
                                  >
                                    {Item.Name}
                                  </option>
                                ))}
                            </select>
                            <a
                              className="th-a"
                              onClick={() => {
                                setShowCurrentLogData(true);
                              }}
                            >
                              Show Values From this file
                            </a>
                          </div>
                        </th>
                      )}
                    </tr>
                    <tr className="lg-row">
                      <th className="white-back"></th>
                      <th className="white-back"></th>
                      {showCurrentLogData && (
                        <>
                          <th colSpan={3}>PFI Brand 3</th>
                          <th colSpan={3}>PFI Brand 4</th>
                          <th colSpan={3}>All Brands</th>
                        </>
                      )}
                      {!showCurrentLogData && (
                        <>
                          <th colSpan={3}>PFI Brand 3</th>
                          <th colSpan={3}>PFI Brand 4</th>
                          <th colSpan={3}>All Brands</th>
                        </>
                      )}
                    </tr>
                    <tr className="lg-row">
                      <th className="white-back"></th>
                      <th className="white-back"></th>
                      {showCurrentLogData && (
                        <>
                          <th>List Price</th>
                          <th>Options Price</th>
                          <th>Total</th>
                          <th>List Price</th>
                          <th>Options Price</th>
                          <th>Total</th>
                          <th>List Price</th>
                          <th>Options Price</th>
                          <th>Total</th>
                        </>
                      )}
                      {!showCurrentLogData && (
                        <>
                          <th>List Price</th>
                          <th>Options Price</th>
                          <th>Total</th>
                          <th>List Price</th>
                          <th>Options Price</th>
                          <th>Total</th>
                          <th>List Price</th>
                          <th>Options Price</th>
                          <th>Total</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {copaSummaryData &&
                      copaSummaryData.map((item: any, index: any) => (
                        <React.Fragment key={"LogSummary" + index}>
                          <tr>
                            <td>{item.MarketName}</td>
                            <td>{item.DealerName}</td>
                            {showCurrentLogData && (
                              <>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {item.JaguarListPriceLCForCurrentLog?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {item.JaguarOptionsPriceLCForCurrentLog?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.JaguarListPriceLCForCurrentLog +
                                    item.JaguarOptionsPriceLCForCurrentLog
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {item.LandRoverListPriceLCForCurrentLog?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {item.LandRoverOptionsPriceLCForCurrentLog?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.LandRoverListPriceLCForCurrentLog +
                                    item.LandRoverOptionsPriceLCForCurrentLog
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.JaguarListPriceLCForCurrentLog +
                                    item.LandRoverListPriceLCForCurrentLog
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.JaguarOptionsPriceLCForCurrentLog +
                                    item.LandRoverOptionsPriceLCForCurrentLog
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.JaguarListPriceLCForCurrentLog +
                                    item.LandRoverListPriceLCForCurrentLog +
                                    item.JaguarOptionsPriceLCForCurrentLog +
                                    item.LandRoverOptionsPriceLCForCurrentLog
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                              </>
                            )}
                            {!showCurrentLogData && (
                              <>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {item.JaguarListPriceLCForCurrentQuarter?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {item.JaguarOptionsPriceLCForCurrentQuarter?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.JaguarListPriceLCForCurrentQuarter +
                                    item.JaguarOptionsPriceLCForCurrentQuarter
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {item.LandRoverListPriceLCForCurrentQuarter?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {item.LandRoverOptionsPriceLCForCurrentQuarter?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.LandRoverListPriceLCForCurrentQuarter +
                                    item.LandRoverOptionsPriceLCForCurrentQuarter
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.JaguarListPriceLCForCurrentQuarter +
                                    item.LandRoverListPriceLCForCurrentQuarter
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.JaguarOptionsPriceLCForCurrentQuarter +
                                    item.LandRoverOptionsPriceLCForCurrentQuarter
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                                <td className="text-right">
                                  {showInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        item.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    "$"
                                  )}
                                  {(
                                    item.JaguarListPriceLCForCurrentQuarter +
                                    item.LandRoverListPriceLCForCurrentQuarter +
                                    item.JaguarOptionsPriceLCForCurrentQuarter +
                                    item.LandRoverOptionsPriceLCForCurrentQuarter
                                  )?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </td>
                              </>
                            )}
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className="help-btns">
                <a onClick={() => setshowCopaSummary(false)}>Close</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default COPA;
